import { getApis } from '../../library/Apis';
import api from '../../services/api';
import { toRequest } from '../../utils/RequestUtils';

const getUsuarioEndpoint = () => {
  return getApis().apis.users + 'v1/usuario/';
};

export const trocarSenha = (data, callbackSuccess, callbackError) => {
  return () => {
    toRequest(
      api.put,
      [getUsuarioEndpoint() + 'trocar-senha', data],
      'save'
    ).then(
      () => {
        if (typeof callbackSuccess === 'function') {
          callbackSuccess();
        }
      },
      (error) => {
        if (typeof callbackError === 'function') {
          callbackError(error);
        }
      }
    );
  };
};
